export const billersFixture: Map<string, string> = new Map<string, string>([
    ['0004', 'assets/images/logo-telcel.svg'],
    ['1011', 'assets/images/logo-telcel.svg'],
    ['0005', 'assets/images/logo-at&t.svg'],
    ['1015', 'assets/images/logo-at&t.svg'],
    ['1014', 'assets/images/logo-movistar.svg'],
    ['0006', 'assets/images/logo-movistar.svg'],
]);